import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'motn-fa-icon',
  imports: [],
  templateUrl: './fa-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './fa-icon.component.scss'
})
export class FaIconComponent {
  @Input() icon: string;
}
